import {Queries} from '../api/queries';
import {Select} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';
import {SyntheticEvent, useCallback} from 'react';

interface CustomerPickerProps {
	id: string;
	selectedCustomerId: string | null;
	onChange: (selectedCustomerId: string) => void;
	disabled?: boolean;
}

const CustomerPicker = ({id, selectedCustomerId, onChange, disabled}: CustomerPickerProps) => {
	const {data: customers} = useQuery(Queries.customers());

	const onCustomerSelected = useCallback(
		(event: SyntheticEvent<HTMLSelectElement>) => {
			const newId = event.currentTarget.value;

			// A safety measure in case they're able to select the null option somehow
			if (newId) {
				onChange(newId);
			}
		},
		[onChange],
	);

	return (
		<Select
			id={id}
			name='customerId'
			value={selectedCustomerId ? selectedCustomerId + '' : ''}
			onChange={onCustomerSelected}
			disabled={disabled}
		>
			{selectedCustomerId === null && <option value=''>Select a Customer</option>}
			{(customers ?? []).map(({id, name}) => (
				<option key={id} value={id + ''}>
					{name}
				</option>
			))}
		</Select>
	);
};

export default CustomerPicker;
